import { FC, memo } from 'react'
import { Box, Card, CardProps, Divider, Flex, HStack, Image, Stack, Text } from '@chakra-ui/react'

import { File, FileFilter } from 'DigitalArchive/types'
import { convertBytesNumberToString } from 'utils/transforms/number'
import getAssets from 'utils/assets/getAssets'
import { Highlight, MetadatasList } from 'components'

type Props = CardProps & {
  hasMetadatas?: boolean
  file: File
  fileFilter?: FileFilter
  children?: JSX.Element
}

const FileCard: FC<Props> = ({ hasMetadatas = true, file, fileFilter, children, ...cardProps }) => {
  const fileImage = getAssets('File', file.extension ? file.extension.toLowerCase() : 'blank')

  return (
    <Card
      p={2}
      borderWidth="1px"
      borderColor="borderColor"
      height="100%"
      width="100%"
      className="accessible"
      _hover={{ bg: 'lightPrimary' }}
      {...cardProps}
    >
      <Stack>
        <Flex gap={2} flexWrap="wrap" width="100%" align="center" justify="space-between">
          <HStack>
            <Image boxSize="40px" backgroundSize="cover" src={fileImage} alt={file.name} />

            <Stack spacing={1}>
              <Text wordBreak="break-word">
                <Highlight query={fileFilter?.name}>{file.name || file.original_name || ''}</Highlight>
              </Text>
              <Text textAlign="left" variant="secondary">
                {file.extension ? file.extension.toUpperCase() : ''}
                {file.size && `, ${convertBytesNumberToString(file.size)}`}
              </Text>
            </Stack>
          </HStack>
        </Flex>

        {children && <Box width="100%">{children}</Box>}

        {hasMetadatas && (
          <>
            <Divider />
            <MetadatasList showFeedbackVariant="ONLY_TEXT" entity={file} metadataPrefix="archive_info" />
          </>
        )}
      </Stack>
    </Card>
  )
}

export default memo(FileCard)
